const partnerEnv = require('./config/partner')
const loader = require('./config/loader')
const flowSettings = require('./config/settings')
const flowVariants = require('./config/variants')


const getPath = (variantName, i18n) => {
  let pathConf = require(`./variant-flows/${variantName}`)(i18n);

  if (pathConf[0]) {
    pathConf[0].screens = [
      ...pathConf[0].screens,
    ];
  }

  return pathConf;
};

let variant = "igaming"
/* not roots */
/* not roots */
/* not roots */

const { settings: variantSettings = {} } = flowVariants.find(({ name }) => name === variant) || {};

let config = {
  ...partnerEnv,
  loader,
  settings: flowSettings,
  variants: flowVariants,
  path: (i18n) => getPath(variant, i18n),
}

if (variantSettings) {
  config.settings = {
    ...config.settings,
   ...variantSettings
  }
}

module.exports = config


// WEBPACK FOOTER //
// ./src/partners/partner.module.config.js